import useSWR from 'swr'
import { Startpage_Blocks } from '@graphql/queries'

const useStartpageBlocks = () => {
  const { data, error, mutate, isValidating } = useSWR(Startpage_Blocks)

  return {
    startpageBlocks: data?.startpageBlocks,
    error,
    mutate,
    isValidating,
    isLoading: !error && !data,
  }
}

export { useStartpageBlocks }
